import API from '../../API/api';

function requestSetConfiguratorSource(source) {
    return API.POST({
        apiPath: '/api/v2/configuratorsource/?set=' + source
    }).done(response => {
        return response;
    });
}

export { requestSetConfiguratorSource };
